/* Feature buttons — single-open accordion.
   One shared panel: the open button's <template> is cloned into it, so
   the panel markup exists once rather than four times. */
(function () {
  function init(root) {
    if (root.dataset.eduReady) return;
    root.dataset.eduReady = '1';

    var panel = root.querySelector('.edu__panel');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-edu-btn]'));
    var open = null;

    function close() {
      buttons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      panel.hidden = true;
      panel.innerHTML = '';
      panel.removeAttribute('aria-labelledby');
      open = null;
    }

    function show(id, btn) {
      var tpl = root.querySelector('[data-edu-content="' + id + '"]');
      if (!tpl) return;
      buttons.forEach(function (b) {
        b.setAttribute('aria-expanded', String(b === btn));
      });
      panel.innerHTML = '';
      panel.appendChild(tpl.content.cloneNode(true));
      panel.hidden = false;
      panel.setAttribute('aria-labelledby', btn.id);
      open = id;

      var closeBtn = panel.querySelector('[data-edu-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);

      document.dispatchEvent(new CustomEvent('edu:open', { detail: { id: id } }));
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-edu-btn');
        if (open === id) { close(); return; }
        show(id, btn);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-edu]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot;
    boot();
  }
  // the theme re-renders the product section on variant change
  document.addEventListener('shopify:section:load', boot);
})();
